module.exports = __webpack_public_path__ + "static/Grupo 65-4c6a542efe8cdf0dfd5d19ebdb2cb720.svg";